import Medusa, { Config } from "@medusajs/js-sdk"
import { Vendor } from "utils/api/client/vendors"
import { PomAdmin } from "./pom-admin"
import { CustomAuth } from "./custom-auth"

class MedusaSupportVendor extends Medusa {
  vendor: Vendor
  pomAdmin: PomAdmin
  fetch: any

  constructor(config: Config) {
    super(config)

    this.vendor = new Vendor(this.client, config)
    this.pomAdmin = new PomAdmin(this.client, config)
    // Override the auth property with our custom implementation
    this.auth = new CustomAuth(this.client, config) as any
  }
}

export const apiClient = new MedusaSupportVendor({
  baseUrl: import.meta.env.VITE_MEDUSA_BACKEND_URL,
  auth: {
    type: "jwt",
  },
})

// useful when you want to call the BE from the console and try things out quickly
if (typeof window !== "undefined") {
  ;(window as any).__sdk = apiClient
}
